import { gql } from '@apollo/client';

export const GET_ALL_USERS = gql`
  query GetAllUsers {
    users {
      id
      email
      firstName
      lastName
      phoneNumber
      photoUrl
      createdAt
      updatedAt
    }
  }
`;

export const GET_SIMPLE_CURRENT_USER = gql`
  query GetSimpleCurrentUser {
    me {
      id
      email
      firstName
      lastName
      phoneNumber
      photoUrl
    }
  }
`;

export const DELETE_USER = gql`
  mutation DeleteUser($id: ID!) {
    deleteUser(id: $id)
  }
`;

export const GET_COMPLETE_CURRENT_USER = gql`
  query GetUser {
    me {
      id
      email
      firstName
      lastName
      phoneNumber
      phoneNumbers {
        id
        number
        label
      }
      companyIds
      currentCompanyId
      photoUrl
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_CURRENT_USER = gql`
  mutation UpdateCurrentUser($input: UpdateUserInput!) {
    updateCurrentUser(input: $input) {
      id
      email
      firstName
      lastName
      phoneNumber
      phoneNumbers {
        id
        number
        label
      }
      photoUrl
      companyIds
      currentCompanyId
      createdAt
      updatedAt
    }
  }
`;

/**
 * Everyone who belongs to a company.
 *
 * Membership lives on `User.companyIds`; the `Company.teamMembers` field reads
 * a `teamMemberIds` array that does not exist on the schema, which is why it
 * has always come back empty.
 */
export const GET_COMPANY_TEAM_MEMBERS = gql`
  query GetCompanyTeamMembers($companyId: ID!) {
    companyTeamMembers(companyId: $companyId) {
      id
      email
      name
      firstName
      lastName
    }
  }
`;
